import axios from "axios";
import { bidUrl } from "../../utils";

export const deleteBid = (bidId: string) => {
  return axios.delete(bidUrl(bidId));
};
